export class USER_GROUPS {
    constructor(
        public GROUP_ID: number,
        public GROUP_NAME: string,
        public DESCRIPTION: string,
        public PARENT_GROUP_ID: number,
        public CG_APP: number,
        public CD_APP: string,
        public UD3: number,
        public UD4: number,
        public UD1: number,
        public UD2: number,
        public LOCK_YN: boolean,
        public MULTIPLE: boolean,
        public CREATED_BY: number,
        public D_EXPIRY: Date,
        public SD_EXPIRY: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/group.ts